<template>
    <div class="tabs-component">
        <div class="tabs-container">
            <template v-for="tabItem in tabItems">
                <router-link tag="div" class="tab" :to="tabItem.route" active-class="active-tab" exact>
                    {{tabItem.caption}}
                </router-link>
            </template>
        </div>
        <div class="tabs-content">

        </div>
        <slot></slot>
    </div>
</template>

<script>
    export default {
        name: "RouterTabs",
        props: {
            tabItems: Array
        }
    }
</script>

<style lang="scss" scoped>
    @import "../styles/global";
    .tabs-component {
        width: 100%;
    }

    .tabs-container {
        display: flex;
        flex-flow: row;

    }

    .tab {
        padding: 5px;
    }

    .active-tab {
        color: var(--input-active-font-color);
    }
</style>